import React from 'react';
import { Facebook, Instagram, Twitter, Youtube, Mail } from 'lucide-react';
import { Button } from './ui/Button';
export function Footer() {
  return <footer className="bg-black border-t border-uncommon-grey pt-20 pb-10" data-id="element-61">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-62">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-63">
          {/* Brand */}
          <div className="space-y-6" data-id="element-64">
            <a href="/" className="font-brand text-4xl font-bold tracking-ultra-wide text-white block hover:text-uncommon-gold transition-colors" data-id="element-65">
              <span className="text-uncommon-gold" data-id="element-66">U</span>NCMMN
            </a>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-67">
              Celebrating African-American youth culture through bold fashion,
              premium tech, and authentic lifestyle essentials.
            </p>
            <div className="flex space-x-4" data-id="element-68">
              {[Instagram, Twitter, Facebook, Youtube].map((Icon, i) => <a key={i} href="#" className="text-gray-400 hover:text-uncommon-gold transition-colors" data-id="element-69">
                  <Icon size={20} data-id="element-70" />
                </a>)}
            </div>
          </div>

          {/* Links */}
          <div data-id="element-71">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-72">
              Shop
            </h4>
            <ul className="space-y-4" data-id="element-73">
              {['New Arrivals', 'Best Sellers', 'Apparel', 'Electronics', 'Deals'].map(item => <li key={item} data-id="element-74">
                  <a href="#" className="text-gray-400 hover:text-uncommon-gold transition-colors text-sm" data-id="element-75">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-76">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-77">
              Support
            </h4>
            <ul className="space-y-4" data-id="element-78">
              {['Order Status', 'Shipping & Returns', 'Size Guide', 'FAQ', 'Contact Us'].map(item => <li key={item} data-id="element-79">
                  <a href="#" className="text-gray-400 hover:text-uncommon-gold transition-colors text-sm" data-id="element-80">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Newsletter */}
          <div data-id="element-81">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-82">
              Stay UNCMMN
            </h4>
            <p className="text-gray-400 text-sm mb-4" data-id="element-83">
              Subscribe for exclusive drops and early access.
            </p>
            <form className="space-y-3" onSubmit={e => e.preventDefault()} data-id="element-84">
              <div className="relative" data-id="element-85">
                <input type="email" placeholder="Enter your email" className="w-full bg-uncommon-dark border border-uncommon-grey text-white px-4 py-3 focus:outline-none focus:border-uncommon-gold transition-colors placeholder:text-gray-600" data-id="element-86" />
                <Mail className="absolute right-3 top-3 text-gray-500" size={20} data-id="element-87" />
              </div>
              <Button variant="primary" fullWidth data-id="element-88">
                Subscribe
              </Button>
            </form>
          </div>
        </div>

        <div className="border-t border-uncommon-grey pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-89">
          <p className="text-gray-500 text-sm" data-id="element-90">
            © 2024 UNCMMN. All rights reserved.
          </p>
          <div className="flex space-x-6" data-id="element-91">
            <a href="#" className="text-gray-500 hover:text-white text-sm" data-id="element-92">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-500 hover:text-white text-sm" data-id="element-93">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}